
import { firstValueFrom } from 'rxjs'
import StoreState, { createAppAsyncThunk } from 'store/state'
import * as api from './net'
import { trialTasksSelector } from './selectors'

export const trackTrainingEvent = createAppAsyncThunk(
  'training/trackEvent',
  async (args: { eventCode: string, value?: number }, { dispatch, getState }) => {
    const tasks = trialTasksSelector(getState() as StoreState)
    const task = tasks.find(task => task.code === args.eventCode)
    // Do not track if the task is already completed
    if (task?.completed) {
      return Promise.resolve({ ...args })
    }
    await firstValueFrom(dispatch(api.trackEvent(args.eventCode, args.value)))
    return { ...args }
  }
)
